import { takeLatest } from 'redux-saga/effects';

import {
  LIST_MODULE_TEMPLATES,
  GET_HUBS_SURVEYS,
  SAVE_NEW_TEMPLATE,
  FIND_ONE_TEMPLATE,
  DELETE_TEMPLATE,
} from '../actions';

import {
  fetchModuleTemplates,
  getHubsSurveyList,
  addNewTemplateSaga,
  fetchTemplateToEdit,
  deleteTemplateSaga,
} from './sagas';

export default [
  takeLatest(LIST_MODULE_TEMPLATES, fetchModuleTemplates),
  takeLatest(GET_HUBS_SURVEYS, getHubsSurveyList),
  takeLatest(SAVE_NEW_TEMPLATE, addNewTemplateSaga),
  takeLatest(FIND_ONE_TEMPLATE, fetchTemplateToEdit),
  takeLatest(DELETE_TEMPLATE, deleteTemplateSaga),
];
